module.exports = __webpack_public_path__ + "media/images/ZFF_logo-a840c643b8e557db1eb5b141d617d68a.png";